import React, { useState, useEffect, useMemo, useContext } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import TableHeader from "../Utility/TableHeader";
import HeaderWithButton from "../Utility/HeaderWithButton";
import { Pagination } from "../../helper/HelperTwo";
import Select from "react-select";
import LabelTopView from "../Utility/LabelTopView";
import {
  ChartBarBigIcon,
  CheckCircleIcon,
  ClockIcon,
  EyeIcon,
  PencilIcon,
  XCircleIcon,
} from "lucide-react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import {
  ChatBubbleBottomCenterIcon,
  CheckIcon,
  CurrencyRupeeIcon,
  DocumentChartBarIcon,
  PaperAirplaneIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useToast } from "../../context/ToastProvider";
import { AdjustmentsVerticalIcon } from "@heroicons/react/24/solid";
import { Tooltip } from "react-tooltip";
import QuotationDiscussion from "./QuotationDiscussion";
import { DataContext } from "../../helper/HelperOne";
import { useExcelDownload, usePDFDownload } from "../../helper/HelperTwo";




const QuotationList = () => {
  const userId = JSON.parse(localStorage.getItem("user"))?.id;
  const tabName = localStorage.getItem("tab_name");
  const location = useLocation();
  const { triggerToast } = useToast();
  const {
    status,
    quote_sent_status,
    quote_dashboard_pending,
    quotationsDateFilter,
    typeOfWorkFilter,
    unFollowed,
    typeOfWorkName,
    qDate,
    dateFrom,
    dateTo,
    salesService,
  } = location.state || "";

  const [quotationStats, setQuotationStats] = useState({});
  const { searchData } = useContext(DataContext);
  const [quotation, setQuotation] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [pagination, setPagination] = useState(null);
  const [filter, setFilter] = useState({
    sales_person: "",
    type_of_work: typeOfWorkFilter ? typeOfWorkFilter : typeOfWorkName || "",
    date_filter: quotationsDateFilter || "",
    // date_from: quotationsDateFilter === "custom" && qDate !== "toDate" ? new Date(Date.now()).toISOString().split("T")[0] : dateFrom,
    // date_to: (quotationsDateFilter === "custom" && qDate === "toDate") ? new Date(Date.now()).toISOString().split("T")[0] : dateTo,
    date_from: quotationsDateFilter === "custom" && dateFrom,
    date_to: quotationsDateFilter === "custom" && dateTo,
    labour_name: "",
    status: status || "",
    quote_sent_status: quote_sent_status || "",
    quote_dashboard_pending: quote_dashboard_pending
      ? quote_dashboard_pending
      : false,
    quote_date_filter: "",
    quote_date_from: "",
    quote_date_to: "",
    unfollow: unFollowed,
    sales_service: salesService || tabName || "",
    project_manager: "",
  });

  const [salesmanData, setSalesmanData] = useState([]);
  const [workersData, setWorkersData] = useState([]);
  const [typeOfWork, setTypeOfWork] = useState([]);
  const [filtersReset, setFiltersReset] = useState(false);
  const [colors, setColors] = useState([]);
  const [isEditStatus, setIsEditStatus] = useState(false);
  const [editStatus, setEditStatus] = useState(false);
  const [editStatusRow, setEditStatusRow] = useState(null); // stores // the id_crypt of the row being edited
  const [editQuotationStatusRow, setEditQuotationStatusRow] = useState(null); // stores // the id_crypt of the row being edited
  const [statusValue, setStatusValue] = useState("");
  const [quotaSendStatusValue, setQuotaSendStatusValue] = useState("");
  const [projectManagerList, setProjectManagerList] = useState([]);
  const [allQuotationDatas, setAllQuotationDatas] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [value, setValue] = useState(0);
  const [dashboardCounts, setDashboardCounts] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [quotationDiscussion, setQuotationDiscussion] = useState(false);
  const [quotationId, setQuotationId] = useState(null);
  const { PDFDownload } = usePDFDownload();
  const { excelDownload } = useExcelDownload();

  const fetchQuotation = async (page = 1) => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const [
        response,
        salesmanResponse,
        typeOfWork,
        workersResponse,
        projectManagerResponse,
      ] = await Promise.all([
        axios.get(`public/api/quotations?page=${page}`, {
          params: {
            status: filter?.status || "",
            quote_sent_status: filter?.quote_sent_status || "",
            quote_dashboard_pending: filter?.quote_dashboard_pending || false,
            date_filter: filter?.date_filter,
            date_from: filter?.date_from,
            date_to: filter?.date_to,
            unfollow: filter?.unfollow,
            type_of_work: filter?.type_of_work,
            sales_service: filter?.sales_service,
            search: searchData,
          },
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`public/api/salesmen/list`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`public/api/type-of-works/list`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`public/api/workers/list`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`public/api/project-manager/list`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      setProjectManagerList(projectManagerResponse?.data);
      setWorkersData(workersResponse.data);
      setTypeOfWork(typeOfWork?.data);
      setSalesmanData(salesmanResponse?.data);
      setQuotationStats(response?.data.stats);
      setDashboardCounts(response?.data?.stats);
      setCurrentPage(response?.data?.data?.current_page);

      if (response.data.success) {
        const quotationData = response?.data?.data?.data || [];

        const uniqueWorks = [
          ...new Set(quotationData.map((q) => q.type_of_work).filter(Boolean)),
        ];
        const colorList = generateColors(uniqueWorks.length);
        setQuotation(response?.data?.data?.data);
        setPagination(response?.data?.data);
        setColors(colorList);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      }
      setError("Network Failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuotation();
    setFiltersReset(false);
  }, [filtersReset, searchData]);




  const headers = [
    "S No",
    "Enquiry No",
    "Quote No",
    "Party Name",
    "Mobile No",
    "Type of Work",
    "Sales/Service",
    "Sales Person",
    "Project Manager",
    "Labour Name",
    "Sales Ledger",
    "Created Date  ",
    "Create Date Difference (One Day)",
    "Next Follow-up date",
    "OverDue Days (On Days)",
    "Quote Amount",
    "Quote Sent Status",
    "Quote Sent Date",
    "Quotation Status",
    "Actions",
  ];

  const handlePageChange = (page) => {
    if (page !== "...") {
      handleFilter(page, filter.type_of_work);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };


  const handleDownloadPDF = () => {
    const params = {
      sales_person: filter.sales_person,
      type_of_work: filter.type_of_work || "",
      date_filter: filter.date_filter,
      date_from: filter.date_from ? filter.date_from : "",
      date_to: filter.date_to,
      labour_name: filter?.labour_name,
      status: filter?.status || "",
      quote_sent_status: filter?.quote_sent_status,
      quote_date_filter: filter?.quote_date_filter,
      quote_date_from: filter?.quote_date_from,
      quote_date_to: filter?.quote_date_to,
      sales_service: filter?.sales_service,
      project_manager: filter?.project_manager,
    };

    PDFDownload("quotations", "quotations.pdf", params, setLoading);
  };

  const handleDownloadExcel = () => {
    const params = {
      sales_person: filter.sales_person,
      type_of_work: filter.type_of_work || "",
      date_filter: filter.date_filter,
      date_from: filter.date_from ? filter.date_from : "",
      date_to: filter.date_to,
      labour_name: filter?.labour_name,
      status: filter?.status || "",
      quote_sent_status: filter?.quote_sent_status,
      quote_date_filter: filter?.quote_date_filter,
      quote_date_from: filter?.quote_date_from,
      quote_date_to: filter?.quote_date_to,
      sales_service: filter?.sales_service,
      project_manager: filter?.project_manager,
    };


    excelDownload("quotations", "quotation.xlsx", params, setLoading);
  };

  const handleFilter = async (page = 1, type_of_work) => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");
      const queryParams = new URLSearchParams({
        page: page,

        sales_person: filter.sales_person,
        type_of_work: filter.type_of_work || type_of_work || "",
        date_filter: filter.date_filter,
        date_from: filter.date_from ? filter.date_from : "",
        date_to: filter.date_to,
        labour_name: filter?.labour_name,
        status: filter?.status || "",
        quote_sent_status: filter?.quote_sent_status,
        quote_date_filter: filter?.quote_date_filter,
        quote_date_from: filter?.quote_date_from,
        quote_date_to: filter?.quote_date_to,
        sales_service: filter?.sales_service,
        project_manager: filter?.project_manager,
        search: searchData,

      }).toString();

      const response = await axios.get(`public/api/quotations?${queryParams}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response?.data?.success) {
        setQuotation(response?.data?.data?.data);
        setPagination(response?.data?.data);
        setQuotationStats(response?.data.stats);
        setDashboardCounts(response?.data?.stats);
        setCurrentPage(response?.data?.data?.current_page);


        const quotationData = response?.data?.data?.data || [];

        const uniqueWorks = [
          ...new Set(quotationData.map((q) => q.type_of_work).filter(Boolean)),
        ];
        const colorList = generateColors(uniqueWorks.length);
           setColors(colorList);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      }
      setError("Network Failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = async () => {
    setLoading(true);
    setFilter({
      sales_person: "",
      type_of_work: "",
      date_filter: "",
      date_from: "",
      date_to: "",
      labour_name: "",
      status: "",
      quote_sent_status: "",
      quote_date_filter: "",
      quote_date_from: "",
      quote_date_to: "",
      unfollow: "",
      sales_service: tabName || "",
      project_manager: "",
    });
    setLoading(false);
    setFiltersReset(true);
  };

  useEffect(() => {
    if (filtersReset) {
      fetchQuotation();
      setFiltersReset(false);
    }
  }, [filtersReset]);




  const handleForLead = (id_crypt) => {

    if (id_crypt == null) {
      triggerToast("error", "No Lead Found", "error");
      return;
    } {
      navigate("/crm/lead", {
        state: {
          lead_id_crypt: id_crypt,
        },
      });
    }
  };

  const colorClasses = [
    "border-blue-500 text-blue-500",
    "border-green-500 text-green-500",
    "border-red-500 text-red-500",
    "border-yellow-500 text-yellow-500",
    "border-purple-500 text-purple-500",
    "border-pink-500 text-pink-500",
    "border-indigo-500 text-indigo-500",
  ];

  const getRandomColor = (colors) => {
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const randomColorMap = useMemo(() => {
    const map = {};
    if (!quotation || quotation.length === 0 || !colors?.length) return map;

    const uniqueWorks = [
      ...new Set(quotation.map((lead) => lead?.type_of_work).filter(Boolean)),
    ];

    uniqueWorks.forEach((work, index) => {
      map[work] = colors[index % colors.length]; // assign color deterministically
    });

    return map;
  }, [quotation, colors]);

  const generateColors = (count) => {
    // const colors = [];
    // for (let i = 0; i < count; i++) {
    //   const color = `#${Math.floor(Math.random() * 16777215)
    //     .toString(16)
    //     .padStart(6, "0")}`;
    //   colors.push(color);
    // }
    // return colors;

    const colors = [];

    for (let i = 0; i < count; i++) {
      const hue = Math.floor(Math.random() * 360); // full color range
      const saturation = Math.floor(Math.random() * 40) + 70; // 70–100% = very colorful
      const lightness = Math.floor(Math.random() * 30) + 25; // 60–90% = bright

      const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      colors.push(color);
    }

    return colors;
  };

  if (loading) {
    return (
      <div className="h-screen bg-white">
        <div className="flex justify-center items-center h-full">
          <img
            className="h-16 w-16"
            src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
            alt="loader"
          />
        </div>
      </div>
    );
  }


  if (error) {
    return (
      <div className="h-screen bg-white flex flex-col justify-center items-center">
        <p className="mb-4 text-red-600 font-medium">Something went wrong.</p>
        <button
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          onClick={() => {
            setError(null); // hide error while retrying
            fetchQuotation(); // retry API
          }}
        >
          Reload
        </button>
      </div>
    )
  }

  const handleUpdateStatus = async (id_crypt, sent_status = false) => {
    setLoading(true);

    let params = "";
    if (sent_status) {
      params = {
        quote_sent_status: quotaSendStatusValue,
      };
    } else {
      params = {
        status: statusValue,
      };
    }

    try {
      const response = await axios.put(
        `public/api/quotations/${id_crypt}`,
        params, // request body
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      triggerToast("success", "Status updated successfully"); // optional success message
      handleFilter(currentPage); // Refresh the list to show updated status
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm/");
      } else {
        triggerToast(
          "error",
          error.response?.data?.message || "Something went wrong",
          "error"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const salesServiceOptions = [
    {
      value: "sales",
      name: "Sales",
    },
    {
      value: "service",
      name: "Service",
    },
  ];

  // const projectManager = projectManagerList?.map((sales) => ({
  //   id: sales.id,
  //   name: sales?.name,
  // }));

  const handleViewFordiscussion = (id) => {
    setQuotationDiscussion(true);
    setQuotationId(id);
  };

  const handleViewClose = () => {
    setQuotationDiscussion(false);
    fetchQuotation();
  };

  return (
    <div>
      <div className="flex flex-col lg:flex-row justify-between items-center gap-4 mb-4">
        <div className="flex-1">
          <LabelTopView label="Quotation Overview" icon={<ChartBarBigIcon />} />
        </div>

        {/* <div className="bg-white shadow-md rounded-xl p-4 border border-gray-200">
              <div className="text-gray-600 text-sm font-medium flex items-center gap-2">
                <span className="text-md">🕒</span> Last Sync @
                <span className="text-indigo-600 italic text-md">
                  {lastSyncDate ? lastSyncDate : "Not synced yet"}
                </span>
              </div>
            </div> */}
      </div>

      <div className="mt-6 overflow-x-auto  rounded-lg shadow-sm border border-gray-300 p-2">
        <table className="table-auto p-5 w-full ">
          <tbody>
            {/* TOTAL QUOTATIONS */}
            {(userId == 1 || userId == 2) && (
              <>
                <tr className="bg-gradient-to-r cursor-pointer from-purple-100 to-purple-50 border border-purple-200 rounded-md shadow mb-2">
                  <td className="flex items-center p-3 text-purple-800 font-semibold rounded-l-md">
                    <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-purple-200 text-purple-600 mr-2 rotate-[-90deg]" />
                    Total Quotations
                  </td>
                  <td
                    className="text-[20px] font-bold text-purple-700 text-right p-3"
                    id="total-quotations"
                  >
                    {dashboardCounts.totalQuotations || 0}
                  </td>
                  <td className="text-center">
                    <button
                      className=" rounded-full  text-white transition-colors"
                      onClick={() => {
                        setIsOpen(true);
                        setSelectedRow("Total Quotation Amount");
                        setValue(dashboardCounts.quotationTotalValue);
                      }}
                    >
                      <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                    </button>
                  </td>
                </tr>

                {/* QUOTATIONS NOT SENT */}
                <tr className="bg-gradient-to-r cursor-pointer from-red-100 to-red-50 border border-red-200 rounded-md shadow mb-2">
                  <td className="flex items-center p-3 text-red-700 font-semibold rounded-l-md">
                    <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-red-200 text-red-500 mr-2 rotate-[-90deg]" />
                    Quotations Not Sent
                  </td>
                  <td className="text-[20px] font-bold text-red-600 text-right p-3">
                    {dashboardCounts.quotationsNotSentCount || 0}
                  </td>

                  <td className="text-center">
                    <button
                      className="p-2 rounded-full text-white transition-colors"
                      onClick={() => {
                        setIsOpen(true);
                        setSelectedRow("Quotations Not Sent Amount");
                        setValue(dashboardCounts.quotationNotSendValue);
                      }}
                    >
                      <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                    </button>
                  </td>
                </tr>

                {/* QUOTATIONS SENT */}
                <tr className="bg-gradient-to-r cursor-pointer from-green-50 to-green-100 border border-green-200 rounded-md shadow mb-2">
                  <td className="flex items-center p-3 text-green-800 font-semibold rounded-l-md">
                    <PaperAirplaneIcon className="w-6 h-6 p-0.5 rounded-full bg-green-100 text-green-600 mr-2 rotate-[-90deg]" />
                    Quotations Sent
                  </td>
                  <td className="text-[20px] font-bold text-green-700 text-right p-3">
                    {dashboardCounts.quotationsSentCount || 0}
                  </td>
                  {/* <td className="text-[20px] font-bold text-green-700 text-right p-3 rounded-r-md">
                      ₹ {allQuotationDatas.quotationSendValue}
                    </td> */}
                  <td className="text-center">
                    <button
                      className="p-2 rounded-full text-white transition-colors"
                      onClick={() => {
                        setIsOpen(true);
                        setSelectedRow("Quotation Sent Amount");
                        setValue(dashboardCounts.quotationSendValue);
                      }}
                    >
                      <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                    </button>
                  </td>
                </tr>

                {/* WON */}
                <tr className="bg-gradient-to-r cursor-pointer from-green-100 to-green-50 text-green-800 border border-green-200 rounded-md shadow mb-2">
                  <td className="flex items-center p-2 col-span-2 font-semibold">
                    <span className="w-2.5 h-2.5 bg-green-500 rounded-full mr-2"></span>
                    Win
                  </td>
                  <td className="text-[20px] font-semibold text-right p-2">
                    {dashboardCounts.quotationWon || 0}
                  </td>

                  <td className="text-center">
                    <button
                      className="p-2 rounded-full text-white transition-colors"
                      onClick={() => {
                        setIsOpen(true);
                        setSelectedRow("Win Amount");
                        setValue(dashboardCounts.quotationTotalValueWon);
                      }}
                    >
                      <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                    </button>
                  </td>
                </tr>

                {/* LOST */}
                <tr className="bg-gradient-to-r cursor-pointer from-red-100 to-red-50 text-red-700 border border-red-200 rounded-md shadow mb-2">
                  <td className="flex items-center p-2 col-span-2 font-semibold">
                    <span className="w-2.5 h-2.5 bg-red-500 rounded-full mr-2"></span>
                    Lost
                  </td>
                  <td className="text-[20px] font-semibold text-right p-2">
                    {dashboardCounts.quotationLost || 0}
                  </td>

                  <td className="text-center">
                    <button
                      className="p-2 rounded-full text-white transition-colors"
                      onClick={() => {
                        setIsOpen(true);
                        setSelectedRow("Lost Amount");
                        setValue(dashboardCounts.quotationTotalValueLost);
                      }}
                    >
                      <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                    </button>
                  </td>
                </tr>

                {/* FOLLOW-UP */}
                <tr className="bg-gradient-to-r cursor-pointer from-yellow-100 to-yellow-50 text-yellow-800 border border-yellow-200 rounded-md shadow mb-2">
                  <td className="flex items-center p-2 col-span-2 font-semibold">
                    <span className="w-2.5 h-2.5 bg-yellow-400 rounded-full mr-2"></span>
                    Follow-up
                  </td>
                  <td className="text-[20px] font-semibold text-right p-2">
                    {dashboardCounts.quotationFollowup || 0}
                  </td>
                  <td className="text-center">
                    <button
                      className="p-2 rounded-full text-white transition-colors"
                      onClick={() => {
                        setIsOpen(true);
                        setSelectedRow("Follow-up Amount");
                        setValue(dashboardCounts.quotationTotalValueFollowup);
                      }}
                    >
                      <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                    </button>
                  </td>
                </tr>
              </>
            )}

            {/* FOLLOW-UP DETAILS: TODAY */}
            <tr className="bg-white border-l-4 border-blue-500 rounded-md shadow mb-1">
              <td className="p-2 text-gray-700 font-semibold cursor-pointer">
                Today's Count
              </td>
              <td className="text-blue-600 text-[20px] font-semibold text-right p-2">
                {dashboardCounts.quotationFollowupToday || 0}
              </td>

              <td className="text-center">
                <button
                  className="p-2 rounded-full text-white transition-colors"
                  onClick={() => {
                    setIsOpen(true);
                    setSelectedRow("Today's Amount");
                    setValue(dashboardCounts.quotationFollowupAmountToday);
                  }}
                >
                  <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                </button>
              </td>
            </tr>

            {/* FOLLOW-UP DETAILS: FUTURE */}
            <tr className="bg-white border-l-4 border-purple-500 rounded-md shadow mb-1">
              <td className="p-2 text-gray-700 font-semibold cursor-pointer">
                Future Count
              </td>
              <td className="text-purple-600 text-[20px] font-semibold text-right p-2">
                {dashboardCounts.quotationFollowupFuture || 0}
              </td>

              <td className="text-center">
                <button
                  className="p-2 rounded-full text-white transition-colors"
                  onClick={() => {
                    setIsOpen(true);
                    setSelectedRow("Future Amount");
                    setValue(dashboardCounts.quotationFollowupFutureAmount);
                  }}
                >
                  <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                </button>
              </td>
            </tr>

            {/* FOLLOW-UP DETAILS: UNFOLLOWED */}
            <tr className="bg-white border-l-4 border-gray-400 rounded-md shadow mb-1">
              <td className="p-2  text-gray-700 font-semibold cursor-pointer">
                Unfollow-up Count
              </td>
              <td className="text-gray-700 text-[20px] font-semibold text-right p-2">
                {dashboardCounts.quotationFollowupOverdue || 0}
              </td>

              <td className="text-center">
                <button
                  className="p-2 rounded-full text-white transition-colors"
                  onClick={() => {
                    setIsOpen(true);
                    setSelectedRow("Unfollow-Up Amount");
                    setValue(dashboardCounts.quotationFollowupOverdueAmount);
                  }}
                >
                  <CurrencyRupeeIcon className="w-6 h-6 sm:w-9 sm:h-9 text-purple-800 mt-2" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* <div className="grid">
        <div className="shadow-sm">
          <div className="grid  sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 ">
            {(userId === 1 || userId === 2) && (
              <>
             
                <div className="flex flex-col items-right justify-right p-6 m-2 bg-indigo-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-indigo-200 rounded-full">
                      <AdjustmentsVerticalIcon className="h-6 w-6  text-indigo-700" />
                    </div>
                    <div>
                      <div className="text-gray-500 font-medium text-md">
                        Total Quotations
                      </div>
                      <div className="text-indigo-900 font-bold text-2xl">
                        {quotationStats?.totalquotes}
                      </div>
                    </div>
                  </div>
                </div>

               
                <div className="flex flex-col items-right justify-right gap-2 p-6 m-2 bg-green-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-green-200 rounded-full">
                      <CheckCircleIcon className="h-6 w-6  text-green-700" />
                    </div>

                    <div>
                      <div className="text-gray-500 font-medium text-md">
                        Win Quotations
                      </div>
                      <div className="text-green-900 font-bold text-2xl">
                        {quotationStats?.totalWinQuotes}
                      </div>
                    </div>
                  </div>
                </div>

                
                <div className="flex flex-col items-right justify-right gap-2 p-6 m-2 bg-red-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-red-200 rounded-full">
                      <XCircleIcon className="h-6 w-6  text-red-700" />
                    </div>
                    <div>
                      <div className="text-gray-500 font-medium text-md">
                        Lost Quotations
                      </div>
                      <div className="text-red-900 font-bold text-2xl">
                        {quotationStats?.totalLossQuotes}
                      </div>
                    </div>
                  </div>
                </div>

                
                <div className="flex flex-col items-right justify-right gap-2 p-6 m-2 bg-yellow-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-yellow-200 rounded-full">
                      <ClockIcon className="h-6 w-6  text-yellow-700" />
                    </div>
                    <div>
                      <div className="text-gray-500 font-medium text-md">
                        Follow-up Quotations
                      </div>
                      <div className="text-yellow-900 font-bold text-2xl">
                        {quotationStats?.totalFollowupQuotes}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="flex flex-col items-right justify-right gap-2 p-6 m-2 bg-gray-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-gray-200 rounded-full">
                  <ClockIcon className="h-6 w-6  text-gray-700" />
                </div>
                <div>
                  <div className="text-gray-500 font-medium text-md ">
                    Today Quotations
                  </div>
                  <div className="text-gray-900 font-bold text-2xl">
                    {quotationStats?.quotationFollowupToday}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-right justify-right gap-2 p-6 m-2 bg-orange-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-orange-200 rounded-full">
                  <ClockIcon className="h-6 w-6  text-orange-700" />
                </div>
                <div>
                  <div className="text-orange-500 font-medium text-md">
                    Future Quotations
                  </div>
                  <div className="text-orange-900 font-bold text-2xl">

                    {quotationStats?.quotationFollowupFuture}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-right justify-right gap-2 p-6 m-2 bg-slate-50  rounded-lg shadow hover:shadow-lg hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="flex items-center gap-4 ">
                <div className="p-3 bg-slate-200 rounded-full">
                  <ClockIcon className="h-6 w-6 text-slate-700" />
                </div>
                <div>
                  <div className="text-slate-500 font-medium text-md ">
                    Unfollow-up  Quotations
                  </div>
                  <div className="text-slate-900 font-bold text-2xl">
                    {quotationStats?.quotationFollowupOverdue}
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div> */}

      <HeaderWithButton
        title="Quotation  "
        description="Quotation"
        buttonText="Quotation"
        // onButtonClick={handleAddLead}
        showButton={false}
      />

      <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 items-end mt-4">
        {/* Date filter */}

        {/* salesman Dropdown */}
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sales Person
          </label>
          <Select
            name="sales_person"
            options={salesmanData?.map((cust) => ({
              value: cust.name,
              label: cust.name,
            }))}
            value={
              salesmanData
                ?.map((cust) => ({
                  value: cust.name,
                  label: cust.name,
                }))
                .find((cust) => cust.value === filter.sales_person) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "sales_person",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Sales Person"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Project Manager
          </label>
          <Select
            name="project_manager"
            options={projectManagerList?.map((cust) => ({
              value: cust?.name,
              label: cust?.name,
            }))}
            value={
              projectManagerList
                ?.map((cust) => ({
                  value: cust?.name,
                  label: cust?.name,
                }))
                .find((cust) => cust.value === filter?.project_manager) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "project_manager",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Project Manager"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Labour
          </label>
          <Select
            name="worker_tally_id"
            options={workersData?.map((cust) => ({
              value: cust.name,
              label: cust.name,
            }))}
            value={
              workersData
                ?.map((cust) => ({
                  value: cust.name,
                  label: cust.name,
                }))
                .find((cust) => cust.value === filter.labour_name) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "labour_name",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Labour"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Type of Work
          </label>
          <Select
            name="type_of_work"
            options={typeOfWork?.map((work) => ({
              value: work.name,
              label: work.name,
            }))}
            value={
              // Find the option where option.value matches filter.type_of_work
              typeOfWork
                ?.map((work) => ({ value: work.name, label: work.name }))
                .find((option) => option.value === filter.type_of_work) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "type_of_work",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Type of Work"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sales / Service
          </label>
          <Select
            name="sales_service"
            options={salesServiceOptions?.map((item) => ({
              value: item.value,
              label: item.name,
            }))}
            value={
              salesServiceOptions
                ?.map((item) => ({
                  value: item.value,
                  label: item.name,
                }))
                .find((option) => option.value === filter.sales_service) || null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  name: "sales_service",
                  value: selectedOption?.value || "",
                },
              })
            }
            isMulti={false}
            isClearable={true}
            placeholder="Select Sales / Service"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div>

        {/* <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Status
          </label>
          <Select
            name="lead_status"
            options={statusOptions?.map((item) => ({
              value: item.value,
              label: item.name,
            }))}
            value={
              statusOptions
                ?.map((item) => ({
                  value: item.value,
                  label: item.name,
                }))
                .find((option) => option.value == topFilter.lead_status) ||
              null
            }
            onChange={(selectedOption) =>
              handleChangeForLeadFilter({
                target: {
                  name: "lead_status",
                  value: selectedOption?.value || "",
                },
              })
            }
            isDisabled={isEditing}
            isMulti={false}
            isClearable={true}
            placeholder="Select Status"
            className="react-select-container"
            classNamePrefix="select"
          />
        </div> */}

        <div className="space-y-3 ">
          {/* PO Date Select */}
          <div className="">
            <label className="block text-sm font-medium text-gray-700">
              Status
            </label>
            <select
              name="status"
              value={filter?.status}
              onChange={handleChange}
              className="border border-gray-300 p-2 rounded w-full mt-2"
            >
              <option value="" className="text-gray-300">
                -- Select --
              </option>
              <option value="1. Win">1. Win</option>
              <option value="2. Follow-up">2. Follow-up</option>
              <option value="3. Lost">3. Lost</option>
              {/* <option value="4. Negotiation">4.Negotiation</option> */}
            </select>
          </div>
        </div>

        <div className="space-y-3 ">
          {/* PO Date Select */}
          <div className="">
            <label className="block text-sm font-medium text-gray-700">
              Quote Sent Status
            </label>
            <select
              name="quote_sent_status"
              value={filter?.quote_sent_status}
              onChange={handleChange}
              className="border border-gray-300 p-2 rounded w-full mt-2"
            >
              <option value="" className="text-gray-300">
                -- Select --
              </option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>

        <div className="space-y-3 ">
          {/* PO Date Select */}
          <div className="">
            <label className="block text-sm font-medium text-gray-700">
              Next follow up date
            </label>
            <select
              name="date_filter"
              value={filter?.date_filter}
              onChange={handleChange}
              className="border border-gray-300 p-2 rounded w-full mt-2"
            >
              <option value="" className="text-gray-300">
                -- Select --
              </option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="this_week">This Week</option>
              <option value="this_month">This Month</option>
              <option value="this_year">This Year</option>
              <option value="custom">Custom Range</option>
            </select>
          </div>
        </div>

        {filter.date_filter === "custom" && (
          <>
            <div className="space-y-3 ">
              <div className="">
                <label className="block text-sm font-medium">Date From</label>
                <input
                  type="date"
                  name="date_from"
                  value={filter.date_from}
                  onChange={handleChange}
                  className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                />
              </div>
            </div>
            <div className="space-y-3 ">
              <div className="w-full">
                <label className="block text-sm font-medium">Date To</label>
                <input
                  type="date"
                  name="date_to"
                  value={filter.date_to}
                  onChange={handleChange}
                  className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                />
              </div>
            </div>
          </>
        )}

        <div className="space-y-3 ">
          {/* PO Date Select */}
          <div className="">
            <label className="block text-sm font-medium text-gray-700">
              Quotation create Date
            </label>
            <select
              name="quote_date_filter"
              value={filter.quote_date_filter}
              onChange={handleChange}
              className="border border-gray-300 p-2 rounded w-full mt-2"
            >
              <option value="" className="text-gray-300">
                -- Select --
              </option>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="this_week">This Week</option>
              <option value="this_month">This Month</option>
              <option value="this_year">This Year</option>
              <option value="custom">Custom Range</option>
            </select>
          </div>
        </div>

        {filter.quote_date_filter === "custom" && (
          <>
            <div className="space-y-3 ">
              <div className="">
                <label className="block text-sm font-medium">Date </label>
                <input
                  type="date"
                  name="quote_date_from"
                  value={filter.quote_date_from}
                  onChange={handleChange}
                  className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                />
              </div>
            </div>
            <div className="space-y-3 ">
              <div className="w-full">
                <label className="block text-sm font-medium">Date To</label>
                <input
                  type="date"
                  name="quote_date_to"
                  value={filter.quote_date_to}
                  onChange={handleChange}
                  className="mt-1 w-full rounded border border-gray-300 p-2 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200"
                />
              </div>
            </div>
          </>
        )}
      </div>
      <div className="flex flex-wrap gap-4 mt-4">
        {/* Submit Button */}
        <button
          // ref={submitBtnRef}
          onClick={() => handleFilter(1)}
          className="bg-blue-600 text-white font-semibold py-2 px-6 rounded-md hover:bg-blue-700 transition"
        >
          Submit
        </button>

        {/* Reset Button */}
        <button
          onClick={resetFilters}
          className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
        >
          Reset
        </button>
        <button
          onClick={handleDownloadPDF}
          className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
        >
          PDF
        </button>
        <button
          onClick={handleDownloadExcel}
          className="bg-gray-200 text-gray-800 font-semibold py-2 px-6 rounded-md hover:bg-gray-300 transition"
        >
          Excel
        </button>
      </div>
      <div className="overflow-x-auto mt-8">
        <table className="min-w-full border border-gray-300 border-collapse">
          <TableHeader headers={headers} />
          <tbody>

            {quotation.length > 0 ? (
              quotation.map((data, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="border border-gray-300 whitespace-nowrap text-md sm:pl-4 text-center">
                    {pagination.from + index}
                  </td>
                  <td
                    className="border cursor-pointer border-gray-300 whitespace-nowrap text-md text-blue-500 sm:pl-4 text-center p-5"
                    onClick={() => handleForLead(data?.lead_id_crypt)}
                  >

                    {data.enquiry_no || "N/A"}
                  </td>

                  <td className="border  border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {data.quote_number || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {data.party_name || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-blue-500 sm:pl-4 text-center p-5">
                    {/* {data.mobile_no || "N/A"} */}

                     {data?.mobile_no ? (
                              <a href={`tel:${data.mobile_no}`}>
                                {data.mobile_no}
                              </a>
                            ) : (
                              <span className="text-gray-400">N/A</span>
                            )}
                  </td>

                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    <span
                      className="text-xs rounded px-1"
                      style={{
                        color: randomColorMap[data.type_of_work],
                        border: `1px solid ${randomColorMap[data.type_of_work]
                          }`,
                      }}
                    >
                      {data.type_of_work || "N/A"}
                    </span>
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {data?.sales_service || "N/A"}
                  </td>

                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {data?.sales_person || "N/A"}
                  </td>

                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {data?.project_manager || "N/A"}
                  </td>

                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {data.labour_name || "N/A"}
                  </td>

                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {data?.sales_ledger || "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {data?.quote_date
                      ? new Date(data?.quote_date).toLocaleDateString("en-GB")
                      : "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {data?.createdDayDiff || "-"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">

                    {data?.next_followup_date ? new Date(data?.next_followup_date).toLocaleDateString('en-GB') : "N/A"}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {data.overdueDays || "-"}

                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    ₹{data?.quote_amount || "N/A"}
                  </td>

                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {/* {data.quote_sent_status || "N/A"} */}

                    {editQuotationStatusRow !== data.id_crypt ? (
                      <div className="flex items-center justify-center space-x-2">
                        <span>{data.quote_sent_status || "N/A"}</span>
                        <PencilIcon
                          className="w-6 h-6 text-white bg-green-500 hover:bg-green-600 p-1 rounded cursor-pointer"
                          onClick={() => {
                            setEditQuotationStatusRow(data.id_crypt); // set this row to edit mode
                            setQuotaSendStatusValue(
                              data.quote_sent_status || ""
                            ); // initialize value
                          }}
                        />
                      </div>
                    ) : (
                      <div className="flex items-center justify-center space-x-2">
                        <select
                          value={quotaSendStatusValue}
                          onChange={(e) =>
                            setQuotaSendStatusValue(e.target.value)
                          }
                          className="border border-gray-300 rounded-md p-1 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        >
                          <option value="">Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>

                        <CheckIcon
                          className="w-6 h-6 text-white bg-blue-500 hover:bg-blue-600 p-1 rounded cursor-pointer"
                          onClick={() => {
                            handleUpdateStatus(data.id_crypt, true);
                            setEditQuotationStatusRow(null);
                          }}
                        />
                        <XMarkIcon
                          className="w-6 h-6 text-white bg-red-500 hover:bg-red-600 p-1 rounded cursor-pointer"
                          onClick={() => setEditQuotationStatusRow(null)}
                        />
                      </div>
                    )}
                  </td>

                     <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 sm:pl-4 text-center p-5">
                    {data?.quotation_sent_date? new Date(data?.quotation_sent_date).toLocaleDateString('en-GB'): "N/A"}
                  </td>

                  <td className="border border-gray-300 whitespace-nowrap text-md text-gray-500 text-center p-4">
                    {data.status || "N/A"}
                    {/* {editStatusRow !== data.id_crypt ? (
                      <div className="flex items-center justify-center space-x-2">
                        <span>{data.status || "N/A"}</span>
                        <PencilIcon
                          className="w-6 h-6 text-white bg-green-500 hover:bg-green-600 p-1 rounded cursor-pointer"
                          onClick={() => {
                            setEditStatusRow(data.id_crypt); // set this row to edit mode
                            setStatusValue(data.status || ""); // initialize value
                          }}
                        />
                      </div>
                    ) : (
                      <div className="flex items-center justify-center space-x-2">
                        <select
                          value={statusValue}
                          onChange={(e) => setStatusValue(e.target.value)}
                          className="border border-gray-300 rounded-md p-1 text-gray-700 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        >
                          <option value="">Select</option>
                          <option value="1. Win">Win</option>
                          <option value="2. Follow-up">Follow-up</option>
                          <option value="3. Lost">Lost</option>
                          <option value="4. Negotiation">Negotiation</option>
                        </select>

                        <CheckIcon
                          className="w-6 h-6 text-white bg-blue-500 hover:bg-blue-600 p-1 rounded cursor-pointer"
                          onClick={() => {
                            handleUpdateStatus(data.id_crypt);
                            setEditStatusRow(null); // exit edit mode after updating
                          }}
                        />
                        <XMarkIcon
                          className="w-6 h-6 text-white bg-red-500 hover:bg-red-600 p-1 rounded cursor-pointer"
                          onClick={() => setEditStatusRow(null)} // cancel editing
                        />
                      </div>
                    )} */}
                  </td>
                  <td className="border border-gray-300 whitespace-nowrap text-center align-middle p-5">
                    <div className="flex space-x-2 justify-center items-center">
                      <span
                        className="my-anchor-discussion relative group cursor-pointer bg-orange-400 rounded-md p-1"
                        onClick={() => handleViewFordiscussion(data.id_crypt)}
                      >
                        <ChatBubbleBottomCenterIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-discussion"
                          place="top"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          Discussion
                        </Tooltip>
                      </span>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="12"
                  className="border border-gray-300 text-center py-4 text-gray-500"
                >
                  No Quotation found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {pagination && (
        <Pagination
          links={pagination.links}
          currentPage={pagination.current_page}
          totalResults={pagination.total}
          from={pagination.from}
          to={pagination.to}
          lastPage={pagination.last_page}
          onPageChange={handlePageChange}
        />
      )}

      {/* {isEditStatus && 
        <Transition appear show={isEditStatus} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => setIsEditStatus(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500/75" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-6 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
                  <CheckIcon aria-hidden="true" className="size-6 text-green-600" />
                </div>
                <div className="mt-3 text-center sm:mt-5">
                  <Dialog.Title as="h3" className="text-base font-semibold text-gray-900">
                    Choose Status
                  </Dialog.Title>
                 
                </div>
                <div className="mt-5 sm:mt-6">
                  <button
                    type="button"
                    onClick={() => setIsEditStatus(false)}
                    className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white hover:bg-indigo-500"
                  >
                    Go back to dashboard
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
      
      } */}

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="fixed z-50 inset-0 overflow-y-auto"
      >
        <div className="flex items-center justify-center min-h-screen px-4">
          <Dialog.Overlay className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-300" />
          <div className="bg-white rounded-2xl shadow-xl max-w-md w-full z-50 transition-all">
            <Dialog.Title className="text-lg text-purple-800   sm:text-2xl flex items-center gap-2 font-semibold mb-6 border border-gray-300   rounded-t-2xl px-6 py-2">
              <DocumentChartBarIcon className="h-8 w-8 sm:h-10 sm:w-10 text-purple-800 cursor-pointer " />
              {selectedRow}
            </Dialog.Title>
            <div className="space-y-4 px-6">
              <p className="text-base flex items-center gap-2 sm:text-lg text-slate-700 dark:text-slate-300">
                <span className="font-medium text-md sm:text-lg text-green-700">
                  Value:
                </span>
                <span className="text-green-700 text-md sm:text-lg font-bold">
                  ₹ {value}
                </span>
              </p>
            </div>
            <div className="mt-2 text-right p-4">
              <button
                className="px-3 py-1 bg-blue-600 text-white rounded shadow hover:bg-blue-700 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={quotationDiscussion}
        onClose={() => { }}
        className="relative z-10"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
            <Dialog.Panel className="relative transform overflow-hidden p-2 sm:p-0 rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-5xl sm:p-4">
              <QuotationDiscussion
                close={handleViewClose}
                idCrypt={quotationId}
              />
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default QuotationList;
